/* Sezmar reviews (CRM #2495). Ported from the Kozmetika Hristina kh-reviews section on 2026-10-19;
 * UI strings come from window.SEZR_T (sections/sez-reviews.liquid). Data: api.judge.me reviews_for_widget. */

(function(){
  function __t(k){ var T = window.SEZR_T || {}; return (T[k] != null) ? T[k] : k; }
  function __tr(uuid, body){ var X = window.SEZR_TR || {}, L = __t('lang'); return (uuid && X[uuid] && X[uuid][L]) ? X[uuid][L] : body; }
  if (window.__khrInit) { window.__khrBoot && window.__khrBoot(); return; }
  window.__khrInit = true;

  var SVG_STAR = '<svg class="khr-star{CLS}" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2l2.9 6.3 6.9.6-5.2 4.6 1.6 6.8L12 17.3 5.8 20.9l1.6-6.8L2.2 8.9l6.9-.6L12 2z"/></svg>';
  var SVG_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M9 16.2l-3.5-3.5L4 14.2 9 19.2 20 8.2l-1.5-1.5z"/></svg>';
  var SVG_PLAY  = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>';

  function esc(t){ return (t==null?'':String(t)); } // stored via textContent, no HTML injection

  // Превръща HTML (body_html / reply_content) в чист текст — без изпълнение на скриптове/ресурси
  function htmlToText(html){
    if(!html) return '';
    if(html.indexOf('<')<0) return html;      // вече е чист текст
    var d = document.createElement('div');
    d.innerHTML = html;                        // detached възел: не зарежда ресурси, не изпълнява скриптове
    return (d.textContent || d.innerText || '');
  }

  // ---- imgix helper: преоразмерява снимки на judgeme.imgix.net ----
  function sizeImg(url, w){
    if(!url) return url;
    try{
      var u = new URL(url, location.href);
      u.searchParams.set('auto','format');   // judgeme.imgix.net (вградени данни)
      u.searchParams.set('w', String(w));    // judgeme.imgix.net
      u.searchParams.set('width', String(w));// review-images.judge.me (API данни)
      return u.toString();
    }catch(e){ return url; }
  }

  // ---- извлича вградения JSON от Judge.me (jdgm.data.reviewWidget[ID]) ----
  function extractFromText(txt, pid){
    var key = 'reviewWidget[' + pid + ']';
    var idx = txt.indexOf(key);
    if(idx < 0){
      // резервно: първи reviewWidget[...] обект
      idx = txt.indexOf('reviewWidget[');
      if(idx < 0) return null;
    }
    var eq = txt.indexOf('=', idx);
    var start = txt.indexOf('{', eq);
    if(start < 0) return null;
    var depth=0, inStr=false, esc2=false, q='', end=-1;
    for(var i=start;i<txt.length;i++){
      var c = txt[i];
      if(inStr){ if(esc2){esc2=false;} else if(c==='\\'){esc2=true;} else if(c===q){inStr=false;} continue; }
      if(c==='"'||c==="'"){ inStr=true; q=c; continue; }
      if(c==='{'){ depth++; }
      else if(c==='}'){ depth--; if(depth===0){ end=i+1; break; } }
    }
    if(end<0) return null;
    try{ return JSON.parse(txt.slice(start,end)); }catch(e){ return null; }
  }

  function getReviewData(pid){
    // 1) runtime global
    try{
      if(window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[pid]){
        return jdgm.data.reviewWidget[pid];
      }
    }catch(e){}
    // 2) вграден <script class="jdgm-review-widget-data">
    var nodes = document.querySelectorAll('.jdgm-review-widget-data, script[class*="jdgm-review-widget-data"]');
    for(var n=0;n<nodes.length;n++){
      var data = extractFromText(nodes[n].textContent||'', pid);
      if(data) return data;
    }
    return null;
  }

  // ---- нормализира едно ревю ----
  function normReview(r, cfg){
    var media = [];
    var pics = r.pictures_urls || r.pictures || [];
    if(Array.isArray(pics)){
      pics.forEach(function(p){
        if(!p) return;
        var full = (typeof p === 'string') ? p : (p.original || p.huge || p.large || p.small || p.compact);
        if(full) media.push({ type:'image', full:full });
      });
    }
    if(cfg.enableVideo){
      var vids = r.media_platform_hosted_video_infos || [];
      if(Array.isArray(vids)){
        vids.forEach(function(v){
          if(!v) return;
          var src = v.mp4_url || v.url || v.transcoded_url || v.hls_url || v.playback_url || null;
          var poster = v.thumbnail_url || v.thumbnail || v.poster_url || v.image_url || null;
          if(src || poster) media.push({ type:'video', src:src, poster:poster });
        });
      }
    }
    var body = r.body;
    if((!body || !body.trim()) && r.body_html){ body = htmlToText(r.body_html); }
    return {
      uuid: r.uuid || (r.id!=null?('id-'+r.id):Math.random().toString(36).slice(2)),
      rating: Math.max(0, Math.min(5, parseInt(r.rating,10)||0)),
      title: (r.title||'').trim(),
      body: __tr(r.uuid, (body||'').trim()),
      bodyOrig: (body||'').trim(),
      name: (r.reviewer_name||__t('anonymous')).trim(),
      initial: (r.reviewer_initial || (r.reviewer_name||'?').trim().charAt(0) || '?'),
      verified: !!r.verified_buyer,
      date: r.created_at || r.reviewed_at || null,
      avatar: r.avatar_image_url || null,
      helpful: (parseInt(r.thumb_up,10)||0),
      reply: htmlToText(r.reply_content||'').trim(),
      replyName: (r.shop_reply_name||'').trim(),
      media: media,
      hasMedia: media.length>0
    };
  }

  function starsHTML(rating, sm){
    var out='';
    for(var i=1;i<=5;i++){
      out += SVG_STAR.replace('{CLS}', (sm?' khr-star--sm':'') + (i<=rating?'':' khr-star--empty'));
    }
    return out;
  }

  function fmtDate(iso){
    if(!iso) return '';
    var d = new Date(iso);
    if(isNaN(d.getTime())) return '';
    try{ return d.toLocaleDateString(__t('date_locale'),{day:'numeric',month:'long',year:'numeric'}); }
    catch(e){ return d.toLocaleDateString(); }
  }

  // ============================ ИНСТАНЦИЯ ============================
  function initInstance(root, cfg){
    if(root.__khrDone) return;
    root.__khrDone = true;

    var $ = function(sel){ return root.querySelector(sel); };
    var grid    = $('[data-khr-grid]');
    var skel    = $('[data-khr-skel]');
    var moreWrap= $('[data-khr-more]');
    var moreBtn = $('[data-khr-loadmore]');
    var emptyEl = $('[data-khr-empty]');
    var statusEl= $('[data-khr-status]');
    var statusTx= $('[data-khr-status-text]');

    function fail(reason){
      // Fail-safe: скрий кастъм UI, разкрий native widget-а — без счупен layout
      try{ if(skel && skel.parentNode) skel.remove(); }catch(e){}
      if(statusEl) statusEl.hidden=true;
      if(grid) grid.hidden=true;
      if(moreWrap) moreWrap.hidden=true;
      revealNative(false);
      if(window.console && reason){ try{ console.warn('[kh-reviews] fallback:', reason); }catch(e){} }
    }

    // ---- Judge.me widget endpoint (публичен, БЕЗ токен) — работи с { {product.id} } ----
    function fetchApiPage(page, per){
      var u = new URL('https://api.judge.me/reviews/reviews_for_widget');
      u.searchParams.set('url', cfg.shopDomain);
      u.searchParams.set('shop_domain', cfg.shopDomain);
      u.searchParams.set('platform', 'shopify');
      u.searchParams.set('product_id', cfg.productId);
      u.searchParams.set('page', String(page));
      u.searchParams.set('per_page', String(per));
      return fetch(u.toString(), { headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.ok ? r.json() : Promise.reject(r.status); });
    }

    // Източник на данни: вградени данни (мигновено) ИЛИ директно от API (ако Judge.me не ги е вградил)
    var embedded = getReviewData(cfg.productId);
    if(embedded && embedded.reviews){
      boot(embedded);
    } else {
      if(statusEl){ statusEl.hidden=false; }
      fetchApiPage(1, 50).then(function(j){
        if(j && j.number_of_reviews!=null && j.reviews){ boot(j); }
        else { fail('empty response from the Judge.me API'); }
      }).catch(function(err){ fail('Judge.me API unreachable ('+err+')'); });
    }

    function boot(data){
      if(statusEl) statusEl.hidden=true;
      try{ render(data); }catch(e){ fail(e && e.message); }
    }

    // ------------- native widget helpers (SEO + fallback) -------------
    var NATIVE_SEL = '.jdgm-review-widget, .jdgm-all-reviews-widget, #judgeme_product_reviews, [data-jdgm-widget-type="review-widget"]';
    function nativeNodes(){ return document.querySelectorAll(NATIVE_SEL); }
    // Скриването е CSS-по-подразбиране (body без .khr-native-shown). Тук само превключваме класа.
    function hideNative(){ try{ document.body.classList.remove('khr-native-shown'); }catch(e){} }
    function revealNative(scroll){
      try{ document.body.classList.add('khr-native-shown'); }catch(e){}
      if(scroll){ var n=nativeNodes()[0]; if(n){ try{ n.scrollIntoView({behavior:'smooth',block:'start'}); }catch(e){ n.scrollIntoView(); } } }
    }

    // --------------------------- RENDER ---------------------------
    function render(data){
      // (native widget-ът е скрит по подразбиране от CSS; тук няма нужда да го крием ръчно)

      var reviews = (data.reviews||[]).map(function(r){ return normReview(r, cfg); });
      var total   = parseInt(data.number_of_reviews,10) || reviews.length;
      root.classList.toggle('khr--empty', !total);
      var avg     = parseFloat(data.average_rating) || 0;
      var hist    = data.histogram || [];

      // ---- Summary ----
      var sumEl = $('[data-khr-summary]');
      if(sumEl){
        var avgNum = $('[data-khr-avg]'); if(avgNum) avgNum.textContent = (avg||0).toFixed(1).replace('.', __t('decimal'));
        var avgStars = $('[data-khr-avg-stars]');
        if(avgStars){ avgStars.innerHTML = starsHTML(Math.round(avg)); avgStars.setAttribute('aria-label',__t('avg_prefix')+avg.toFixed(1)+__t('of5')); }
        var cnt = $('[data-khr-count]'); if(cnt) cnt.textContent = total;
        var histEl = $('[data-khr-hist]');
        if(histEl){
          histEl.innerHTML='';
          for(var star=5; star>=1; star--){
            var row = hist.filter(function(h){ return parseInt(h.rating,10)===star; })[0] || {frequency:0,percentage:0};
            var freq = parseInt(row.frequency,10)||0;
            var pct  = (row.percentage!=null) ? row.percentage : (total? Math.round(freq/total*100):0);
            var div = document.createElement('div');
            div.className='khr-hist-row';
            div.innerHTML =
              '<span class="khr-hist-row__stars">'+starsHTML(star,true)+'</span>'+
              '<span class="khr-hist-row__bar"><span class="khr-hist-row__fill" style="width:0%"></span></span>'+
              '<span class="khr-hist-row__num">('+freq+')</span>';
            histEl.appendChild(div);
            (function(fill,pct){ requestAnimationFrame(function(){ setTimeout(function(){ fill.style.width = pct+'%'; },30); }); })(div.querySelector('.khr-hist-row__fill'), pct);
          }
        }
        sumEl.hidden=false;
      }

      // ---- AI summary ----
      var aiEl = $('[data-khr-ai]');
      if(aiEl){
        var aiText = (data.ai_summary_text||'').trim();
        if(!aiText){
          var tpl = $('[data-khr-ai-fallback]');
          if(tpl){
            var tmp=document.createElement('div'); tmp.innerHTML = tpl.innerHTML;
            aiText = (tmp.textContent||'').trim();
          }
        }
        if(aiText && total>0){
          $('[data-khr-ai-text]').textContent = aiText;
          var av = $('[data-khr-ai-avatars]');
          if(av){ av.innerHTML=''; reviews.slice(0,3).forEach(function(rv){ av.appendChild(avatarEl(rv)); }); }
          aiEl.hidden=false;
        }
      }

      // ---- Tools ----
      var toolsEl = $('[data-khr-tools]');
      var sortSel = $('[data-khr-sort]');
      var filterToggle = $('[data-khr-filter-toggle]');
      if(filterToggle && toolsEl){
        filterToggle.addEventListener('click', function(){
          var open = toolsEl.hidden;
          toolsEl.hidden = !open;
          filterToggle.setAttribute('aria-expanded', String(open));
        });
      }
      // Няма отзиви -> няма какво да се сортира/филтрира (но „Напишете отзив“ остава)
      if(total===0){
        if(toolsEl) toolsEl.hidden=true;
        if(filterToggle) filterToggle.style.display='none';
      }

      // ---- State ----
      var state = { sort:'recent', filter:'all', all:reviews.slice(), loadedAll:(reviews.length>=total) };
      var seen = {}; state.all.forEach(function(r){ seen[r.uuid]=1; });
      var renderedIds = {};
      function renderedCount(){ var c=0; for(var k in renderedIds){ if(Object.prototype.hasOwnProperty.call(renderedIds,k)) c++; } return c; }

      function applied(){
        var list = state.all.slice();
        // filter
        if(state.filter==='media'){ list = list.filter(function(r){ return r.hasMedia; }); }
        else if(/^[1-5]$/.test(state.filter)){ var st=parseInt(state.filter,10); list = list.filter(function(r){ return r.rating===st; }); }
        // sort
        if(state.sort==='rating_desc') list.sort(function(a,b){ return b.rating-a.rating; });
        else if(state.sort==='rating_asc') list.sort(function(a,b){ return a.rating-b.rating; });
        else if(state.sort==='helpful') list.sort(function(a,b){ return b.helpful-a.helpful; });
        else list.sort(function(a,b){ return new Date(b.date||0)-new Date(a.date||0); });
        // Приоритет на отзивите със снимки/видео (запазва подредбата в двете групи)
        if(cfg.photosFirst && state.filter!=='media'){
          list = list.filter(function(r){ return r.hasMedia; }).concat(list.filter(function(r){ return !r.hasMedia; }));
        }
        return list;
      }

      function draw(reset){
        var list = applied();
        if(reset){ grid.innerHTML=''; renderedIds = {}; }
        if(skel && skel.parentNode){ skel.remove(); }
        var added=0;
        for(var i=0;i<list.length && added<cfg.perPage;i++){
          var rv=list[i];
          if(renderedIds[rv.uuid]) continue;
          renderedIds[rv.uuid]=1;
          grid.appendChild(card(rv));
          added++;
        }
        if(list.length===0){
          emptyEl.hidden=false;
          emptyEl.textContent = (state.all.length>0) ? __t('no_filter') : __t('empty');
        } else { emptyEl.hidden=true; }

        var remainingLocal = list.length - renderedCount();
        moreWrap.hidden = !(remainingLocal > 0);
        if(remainingLocal > 0) moreBtn.textContent = (cfg.loadMoreText||__t('load_more'));
      }

      // sort/filter listeners
      if(sortSel) sortSel.addEventListener('change', function(){ state.sort=sortSel.value; draw(true); });
      root.querySelectorAll('[data-khr-filter]').forEach(function(btn){
        btn.addEventListener('click', function(){
          root.querySelectorAll('[data-khr-filter]').forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state.filter = btn.getAttribute('data-khr-filter');
          draw(true);
        });
      });

      // load more — всички ревюта са заредени локално, само разкриваме още карти
      moreBtn.addEventListener('click', function(){ draw(false); });

      // ---- Пълно зареждане на ВСИЧКИ ревюта (използва общия fetchApiPage, БЕЗ токен) ----
      function mergeReviews(rawList){
        (rawList||[]).forEach(function(raw){
          var rv = normReview(raw, cfg);
          if(!seen[rv.uuid]){ seen[rv.uuid]=1; state.all.push(rv); }
        });
      }
      function loadAll(){
        var per=50, page=1, guard=0, MAXP=20;  // таван 20 страници = 1000 ревюта
        (function step(){
          fetchApiPage(page, per).then(function(j){
            mergeReviews(j && j.reviews);
            var tp = (j && j.pagination && j.pagination.total_pages) || 1;
            if(page < tp && ++guard < MAXP){ page++; step(); }
            else { state.loadedAll = true; draw(true); }
          }).catch(function(){
            // при мрежова грешка: покажи каквото имаме (вградената първа страница) или native fallback
            state.loadedAll = true;
            if(state.all.length === 0){ fail('reviews_for_widget unreachable'); }
            else { draw(true); }
          });
        })();
      }

      // ---- write review ----
      // Judge.me зарежда формата ЛЕНИВО: първият клик по .jdgm-write-rev-link само зарежда
      // write_review_modal.js; модалът се отваря при следващ клик. Затова кликаме повторно,
      // докато модалът реално се появи.
      var writeBtn = $('[data-khr-write]');
      if(writeBtn){
        writeBtn.addEventListener('click', function(){
          revealNative(false);                                        // махни clip, за да не е клипнат модалът
          try{ window.dispatchEvent(new Event('scroll')); }catch(e){} // подсети Judge.me да зареди формата
          var n=0;
          var iv=setInterval(function(){
            n++;
            var modal=document.querySelector('.jdgm-write-review-modal');
            var open = modal && getComputedStyle(modal).display!=='none';
            if(open){
              clearInterval(iv);
              var inside=false; nativeNodes().forEach(function(nd){ if(nd.contains(modal)) inside=true; });
              if(!inside) setTimeout(hideNative, 300);               // модалът е извън widget-а -> скрий widget-а
              return;
            }
            if(n>20){ clearInterval(iv); revealNative(true); return; } // ~4s fallback: покажи native widget-а
            var link=document.querySelector('.jdgm-review-widget [data-testid="write-review-button"], .jdgm-write-rev-link, .jdgm-write-review-link, [data-jdgm-write-review]');
            if(link){ try{ link.click(); }catch(e){} }
          },200);
        });
      }

      // ---- JSON-LD (по избор, ако native structured data е изключен) ----
      if(cfg.emitJsonLd && total>0){
        emitJsonLd(avg, total, reviews);
      }

      // първо чертане: ако вградените данни съдържат всички ревюта -> рисувай веднага;
      // иначе дозареди всички от Judge.me (skeleton остава докато дойдат)
      buildLightbox(root, cfg);
      if(state.loadedAll){ draw(true); }
      else { loadAll(); }
    }

    // ---------- helpers за карти ----------
    function avatarEl(rv){
      var a = document.createElement('span');
      a.className='khr-avatar';
      if(rv.avatar){
        var img=document.createElement('img');
        img.src=sizeImg(rv.avatar,80); img.alt=''; img.loading='lazy'; img.decoding='async';
        a.appendChild(img);
      } else { a.textContent = (rv.initial||'?').toUpperCase(); }
      return a;
    }

    function card(rv){
      var art = document.createElement('article');
      art.className='khr-card';

      // media
      if(rv.hasMedia){
        var m0 = rv.media[0];
        var btn = document.createElement('button');
        btn.type='button'; btn.className='khr-media';
        btn.setAttribute('aria-label',__t('open_media')+rv.name);
        var img = document.createElement('img');
        img.src = m0.type==='image' ? sizeImg(m0.full,520) : (m0.poster?sizeImg(m0.poster,520):'');
        img.alt = __t('photo_by')+rv.name;
        img.loading='lazy'; img.decoding='async';
        btn.appendChild(img);
        if(m0.type==='video'){
          var play=document.createElement('span'); play.className='khr-media__play';
          play.innerHTML='<span>'+SVG_PLAY+'</span>'; btn.appendChild(play);
        }
        if(rv.media.length>1){
          var badge=document.createElement('span'); badge.className='khr-media__badge';
          badge.textContent='+'+(rv.media.length-1);
          btn.appendChild(badge);
        }
        btn.addEventListener('click', function(){ openLightbox(rv.media, 0); });
        art.appendChild(btn);
      }

      var body=document.createElement('div'); body.className='khr-card__body';

      var head=document.createElement('div'); head.className='khr-card__head';
      head.appendChild(avatarEl(rv));
      var info=document.createElement('div');
      var nm=document.createElement('div'); nm.className='khr-name';
      nm.appendChild(document.createTextNode(rv.name));
      if(rv.verified){ var v=document.createElement('span'); v.className='khr-verified'; v.title=__t('verified'); v.innerHTML=SVG_CHECK; nm.appendChild(v); }
      info.appendChild(nm);
      var st=document.createElement('div'); st.className='khr-card__stars';
      st.setAttribute('role','img'); st.setAttribute('aria-label',__t('rating_prefix')+rv.rating+__t('of5'));
      st.innerHTML=starsHTML(rv.rating,true);
      info.appendChild(st);
      head.appendChild(info);
      body.appendChild(head);

      if(rv.date){ var dt=document.createElement('div'); dt.className='khr-date'; dt.textContent=fmtDate(rv.date); body.appendChild(dt); }
      if(rv.title){ var tt=document.createElement('h3'); tt.className='khr-title'; tt.textContent=rv.title; body.appendChild(tt); }

      if(rv.body){
        var tx=document.createElement('div'); tx.className='khr-text'; tx.textContent=rv.body;
        body.appendChild(tx);
        if(rv.bodyOrig && rv.body!==rv.bodyOrig){
          var trn=document.createElement('div'); trn.className='khr-tr';
          var trl=document.createElement('span'); trl.textContent=__t('translated');
          var trb=document.createElement('button'); trb.type='button'; trb.className='khr-tr__btn'; trb.textContent=__t('see_original');
          trb.addEventListener('click', function(){ var orig = trb.getAttribute('data-orig')==='1';
            tx.textContent = orig ? rv.body : rv.bodyOrig; trb.setAttribute('data-orig', orig?'0':'1');
            trb.textContent = orig ? __t('see_original') : __t('see_translation'); });
          trn.appendChild(trl); trn.appendChild(document.createTextNode(' · ')); trn.appendChild(trb); body.appendChild(trn);
        }
        if(rv.body.length>320){
          tx.classList.add('is-clamped');
          var rm=document.createElement('button'); rm.type='button'; rm.className='khr-readmore'; rm.textContent=__t('read_more');
          rm.addEventListener('click', function(){
            var clamped=tx.classList.toggle('is-clamped');
            rm.textContent = clamped?__t('read_more'):__t('show_less');
          });
          body.appendChild(rm);
        }
      } else if(!rv.title){
        var vb=document.createElement('span'); vb.className='khr-badge-verified';
        vb.textContent = rv.verified ? __t('verified') : __t('no_comment');
        body.appendChild(vb);
      }

      if(rv.reply){
        var rep=document.createElement('div'); rep.className='khr-reply';
        var rn=document.createElement('span'); rn.className='khr-reply__name'; rn.textContent=(rv.replyName||__t('store_reply'));
        rep.appendChild(rn);
        var rt=document.createElement('span'); rt.textContent=rv.reply; rep.appendChild(rt);
        body.appendChild(rep);
      }

      art.appendChild(body);
      return art;
    }

    // ---------- Lightbox ----------
    var lb, lbStage, lbPrev, lbNext, lbCounter, lbMedia=[], lbIndex=0, lastFocus=null;
    function buildLightbox(root, cfg){
      lb = root.querySelector('[data-khr-lb]');
      if(!lb) return;
      lbStage = lb.querySelector('[data-khr-lb-stage]');
      lbPrev = lb.querySelector('[data-khr-lb-prev]');
      lbNext = lb.querySelector('[data-khr-lb-next]');
      lbCounter = lb.querySelector('[data-khr-lb-counter]');
      lb.querySelectorAll('[data-khr-lb-close]').forEach(function(el){ el.addEventListener('click', closeLightbox); });
      lbPrev.addEventListener('click', function(){ step(-1); });
      lbNext.addEventListener('click', function(){ step(1); });
      lb.addEventListener('keydown', function(e){
        if(e.key==='Escape'){ closeLightbox(); }
        else if(e.key==='ArrowLeft'){ step(-1); }
        else if(e.key==='ArrowRight'){ step(1); }
        else if(e.key==='Tab'){ trap(e); }
      });
    }
    function renderStage(){
      var m=lbMedia[lbIndex]; if(!m) return;
      lbStage.innerHTML='';
      if(m.type==='video' && m.src){
        var v=document.createElement('video'); v.src=m.src; v.controls=true; v.autoplay=true; v.playsInline=true;
        if(m.poster) v.poster=m.poster; lbStage.appendChild(v);
      } else {
        var img=document.createElement('img'); img.src=sizeImg(m.full||m.poster,1400); img.alt=__t('media'); img.decoding='async';
        lbStage.appendChild(img);
      }
      var multi=lbMedia.length>1;
      lbPrev.style.display=multi?'':'none';
      lbNext.style.display=multi?'':'none';
      lbCounter.style.display=multi?'':'none';
      lbCounter.textContent=(lbIndex+1)+' / '+lbMedia.length;
    }
    function step(d){ lbIndex=(lbIndex+d+lbMedia.length)%lbMedia.length; renderStage(); }
    window.__khrOpen = openLightbox;
    function openLightbox(media, idx){
      if(!lb) return;
      lbMedia=media||[]; lbIndex=idx||0;
      if(!lbMedia.length) return;
      lastFocus=document.activeElement;
      lb.hidden=false; document.documentElement.style.overflow='hidden';
      renderStage();
      (lb.querySelector('.khr-lb__close')||lb).focus();
    }
    function closeLightbox(){
      if(!lb) return;
      lb.hidden=true; document.documentElement.style.overflow='';
      lbStage.innerHTML='';
      if(lastFocus && lastFocus.focus){ lastFocus.focus(); }
    }
    function trap(e){
      var f=lb.querySelectorAll('button:not([style*="display: none"]),video,[href],[tabindex]:not([tabindex="-1"])');
      f=Array.prototype.filter.call(f,function(el){ return el.offsetParent!==null || el===document.activeElement; });
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    }

    // ---------- JSON-LD ----------
    function emitJsonLd(avg, total, reviews){
      if(document.getElementById('khr-jsonld-'+cfg.id)) return;
      var data={
        "@context":"https://schema.org/","@type":"Product","name":cfg.productTitle,
        "aggregateRating":{"@type":"AggregateRating","ratingValue":Number(avg.toFixed(2)),"reviewCount":total,"bestRating":5,"worstRating":1},
        "review": reviews.slice(0,10).map(function(r){
          return {"@type":"Review",
            "reviewRating":{"@type":"Rating","ratingValue":r.rating,"bestRating":5,"worstRating":1},
            "author":{"@type":"Person","name":r.name},
            "datePublished": r.date ? new Date(r.date).toISOString().slice(0,10) : undefined,
            "reviewBody": r.body||undefined, "name": r.title||undefined };
        })
      };
      var s=document.createElement('script'); s.type='application/ld+json'; s.id='khr-jsonld-'+cfg.id;
      s.textContent=JSON.stringify(data); document.head.appendChild(s);
    }
  }

  // ============================ BOOT ============================
  function boot(){
    var roots = document.querySelectorAll('[data-khr-root]');
    roots.forEach(function(root){
      var id = root.getAttribute('data-khr-id');
      var cfg = (window.KHRConfigs||{})[id];
      if(cfg) initInstance(root, cfg);
    });
  }
  window.__khrBoot = boot;

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  // Theme editor: пре-рендиране при добавяне/промяна на секцията
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-khr-root]');
    if(root){ root.__khrDone=false; boot(); }
  });
})();
